import { useDispatch } from "react-redux";
import { mainActions } from "../../../store";
import classes from "./EarTrainerSetup.module.css";

const EarTrainerChartSelect = ({ charts, selectedIndex }) => {
  const dispatch = useDispatch();

  let options = [];
  for (let n = 0; n < charts.length; n++) {
    options.push(
      <option key={n} value={n}>{`Chart ${n + 1}`}</option>
    );
  }

  const chartChangeHandler = (event) => {
    dispatch(mainActions.setEarTrainerChart(+event.target.value));
  };

  return (
    <tr>
      <td className={classes.td}>
        <select
          aria-label="Practice diagram"
          className={classes.select}
          value={charts.length ? selectedIndex : ""}
          disabled={!charts.length}
          onChange={chartChangeHandler}
        >
          {charts.length ? options : <option value="">No diagrams</option>}
        </select>
      </td>
      <td>Choose the position you want to work on</td>
    </tr>
  );
};

export default EarTrainerChartSelect;
